import { Navigate, useRoutes } from "react-router-dom";
// auth
import RoleBasedGuard from "src/auth/RoleBasedGuard";
// layouts
// MainLayout imported below with other layout imports
// config

// user roles
import { useAuthContext } from "src/auth/useAuthContext";
//
import { useSelector } from "react-redux";
import { SPAR_DISTRIBUTOR_I_CUSTOMER } from "src/constants/distributors";
import { PATH_AFTER_LOGIN } from "../config-global";
// import MainLayout from "../layouts/main"; // Removed in SWOT template cleanup
import SimpleLayout from "../layouts/simple";
import DashboardLayout from "../layouts/dashboard";
import CompactLayout from "../layouts/compact";
import GuestGuard from "../auth/GuestGuard";
import AuthGuard from "../auth/AuthGuard";
import {
  AccountBulkPaymentsPage,
  AddNewReward,
  AddNewRule,
  AgentVideosPage,
  AppUsersPage,
  BatchDetailsPage,
  BatchRequestPage,
  ConsumerVideosPage,
  CraveRewardsPage,
  DistributorNoticesDetailsPage,
  DistributorReportPage,
  DistributorSelfServiceOrderPage,
  IotRulePage,
  ManageReward,
  ManageWebHooksPage,
  ProductDetailsPage,
  ProductGroupDetailsPage,
  ProductGroupPage,
  ProductsPage,
  PromoEngineDashboard,
  PromoEngineLedgerDashboard,
  RewardManagementPages,
  RicaUpliftPage,
  RicaUpliftQueueListPage,
  RulesManagementPage,
  SubDistributorGroupDetailsPage,
  SubDistributorGroupsPage,
  SubDistributorsLevelsPage,
  TrainingVideosPage,
  UploadTrainingVideosPage,
  AccountSelectPage,
  ActiveSubscriptionsDetailsPage,
  ActiveSubscriptionsPage,
  AdminDashboard,
  AdminLoginPage,
  AdminUsersPage,
  //
  BlankPage,
  BulkPaymentsPage,
  ConfirmationPage,
  CreateDistributorNoticesDetailsPage,
  CreateMessagingDetailsPage,
  CreateNoticesDetailsPage,
  CustomerDetailsPage,
  CustomerListPage,
  DashboardGraphsPage,
  DistributorBalancesPage,
  // Dashboard: General
  SPARMobileRetailCommissionDashboard,
  DistributorDashboard,
  DistributorDashboardPage,
  DistributorNoticeListPage,

  // Dashboard: Sim Scan Out
  // SimDetailsPage,
  // Dashboard: Distributor Sim List
  DistributorSimCardsPage,
  // Dashboard: Distributors
  DistributorTransactionsPage,
  // EcommerceCheckoutPage,
  // EcommerceProductCreatePage,
  // EcommerceProductDetailsPage,
  // EcommerceProductEditPage,
  // EcommerceProductListPage,
  // Dashboard: Ecommerce
  // EcommerceShopPage,
  ForgotPasswordPage,
  HoneySalesReportPage,
  IotDetailsPage,
  // Dashboard: IOT
  IotListPage,
  IotUsagePage,
  LMAOnboardingPage,
  LoginPage,
  ManageRule,
  MessagingDetailsPage,
  // Messaging
  MessagingListPage,
  NoticesDetailsPage,
  //  Dashboard: Notices
  NoticesListPage,
  // SIM4Schools Onboarding Form
  OnboardingPage,
  Page403,
  Page404,
  //
  Page500,
  PortDetailsPage,
  // Dashboard: Porting
  PortInListPage,
  PortInStartPage,
  ReportsDetailsPage,
  // Reports
  ReportsListPage,
  ResellerSellProductPage,
  // Dashboard: Resellers
  ResellerTransactionsPage,
  ResetPasswordPage,
  // RetailIncentiveDashboard,
  RicaConfigurationPage,
  RicaDetailsPage,
  RicaListPage,
  RulesManagementProductPage,
  SelfRicaDetailsPage,
  SelfRicaFormPage,
  SelfRicaImageDetailsPage,
  SelfRicaImageListPage,
  // Dashboard: Self Rica
  SelfRicaListPage,
  SimAssignmentPage,
  SimOrdersCreatePage,
  // SimOrdersListPage,
  SimScanOutPage,
  SimScanOutRequestsPage,
  SimStatusPage,
  SimSwapPage,
  SimUnassignmentPage,
  SingleSignOn,
  SubscriptionsPage,
  TopUpPage,
  TupperwareOnboardingPage,
  UserAccountPage,
  // Dashboard: Vouchers
  VoucherDetailsPage,
  VoucherListPage,
  WalletBatchRequestDetailsPage,
  WalletBatchRequestPage,
  WalletMerchantAccountTransactionHistoryPage,
  WalletMerchantAccountsPage,
  WalletReportsPage,
} from "./elements";

// ----------------------------------------------------------------------

export default function Router() {
  const { user } = useAuthContext();
  const selectedRole = useSelector((state) => state.auth.selectedRole);
  const role = selectedRole?.role;
  return useRoutes([
    // Root redirect to /dashboard/app if logged in
    // else redirect to /auth/login-admin
    // /sim4schools needs no login
    {
      path: "/sim4schools",
      element: <SimpleLayout />,
      children: [
        {
          path: "onboarding",
          element: <OnboardingPage />,
        },
        {
          path: "confirmation",
          element: <ConfirmationPage />,
        },
      ],
    },
    {
      path: "/tupperware",
      element: <SimpleLayout />,
      children: [
        {
          path: "onboarding",
          element: <TupperwareOnboardingPage />,
        },
      ],
    },
    {
      path: "/lma",
      element: <SimpleLayout />,
      children: [
        {
          path: "onboarding",
          element: <LMAOnboardingPage />,
        },
      ],
    },
    {
      path: "/",
      element: (
        <AuthGuard>
          <Navigate
            to={
              role === "admin"
                ? PATH_AFTER_LOGIN
                : ["distributor", "sub-distributor", "sub_distributor_manager", "sub_distributor_finance", "referrer", "group_manager"].includes(role)
                  ? "/dashboard/dashboards/distributor"
                  : role === "iot"
                    ? "/dashboard/iot/list"
                    : "/dashboard/rica/form/agent_rica"
            }
          />
        </AuthGuard>
      ),
      children: [
        {
          path: "dashboard",
          element: (
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          ),
        },
      ],
    },
    // Auth
    {
      path: "auth",
      children: [
        {
          path: "account-select",
          element: (
            <GuestGuard>
              <AccountSelectPage />
            </GuestGuard>
          ),
        },
        {
          path: "login-distributor",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: "login-admin",
          element: (
            <GuestGuard>
              <AdminLoginPage />
            </GuestGuard>
          ),
        },
        {
          path: "sso",
          element: (
            <GuestGuard>
              <SingleSignOn />
            </GuestGuard>
          ),
        },
        {
          path: "forgot-password",
          element: (
            <GuestGuard>
              <ForgotPasswordPage />
            </GuestGuard>
          ),
        },
        {
          path: "reset-password",
          element: (
            <GuestGuard>
              <ResetPasswordPage />
            </GuestGuard>
          ),
        },
      ],
    },

    // Dashboard Page
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        {
          element: (
            <Navigate
              to={
                role === "admin"
                  ? PATH_AFTER_LOGIN
                  : ["distributor", "sub-distributor", "sub_distributor_manager", "sub_distributor_manager", "referrer"].includes(role)
                    ? "/dashboard/dashboards/distributor"
                    : role === "iot"
                      ? "/dashboard/iot/list"
                      : "/dashboard/rica/form/agent_rica"
              }
              replace
            />
          ),
          index: true,
        },
        {
          path: "dashboards",
          children: [
            {
              path: "revenue",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <AdminDashboard />
                </RoleBasedGuard>
              ),
            },
            {
              path: "distributor",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "referrer", "group_manager", "sub-distributor", "sub_distributor_manager", "sub_distributor_finance"]}>
                  <DistributorDashboard />
                </RoleBasedGuard>
              ),
            },
            {
              path: "spar-mobile-retail-commission",
              element: (
                <RoleBasedGuard roles={["sub-distributor", "sub_distributor_manager", "sub_distributor_finance"]}>
                  <SPARMobileRetailCommissionDashboard />
                </RoleBasedGuard>
              ),
            },
            {
              path: "crave-rewards",
              element: (
                <RoleBasedGuard roles={["distributor"]} >
                  <CraveRewardsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "balances",
              element: (
                <RoleBasedGuard roles={["distributor", "sub-distributor"]}>
                  <DistributorBalancesPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "promo-engine",
              element: (
                <RoleBasedGuard roles={["distributor", "sub-distributor"]}>
                  <PromoEngineDashboard />
                </RoleBasedGuard>
              ),
            },
            {
              path: "promo-engine-ledger",
              element: (
                <RoleBasedGuard roles={["distributor"]}>
                  <PromoEngineLedgerDashboard />
                </RoleBasedGuard>
              ),
            },
          ],
        },

        {
          path: "app",
          element: (
            <RoleBasedGuard roles={["admin", "distributor", "referrer", "group_manager"]}>
              <DistributorDashboard />
            </RoleBasedGuard>
          ),
        },
        {
          path: "admin",
          children: [
            {
              element: <Navigate to="/dashboard/admin/admin-users" replace />,
              index: true,
            },
            {
              path: "admin-users",
              children: [
                {
                  element: <Navigate to="/dashboard/admin/admin-users/list" replace />,
                  index: true,
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <AdminUsersPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "app-users",
              children: [
                {
                  element: <Navigate to="/dashboard/admin/app-users/list" replace />,
                  index: true,
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin", "distributor", "sub-distributor", "sub_distributor_operations", "sub_distributor_manager"]}>
                      <AppUsersPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "distributor-notices",
              children: [
                {
                  element: <Navigate to="/dashboard/admin/distributor-notices/list" replace />,
                  index: true,
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin", "distributor"]}>
                      <DistributorNoticeListPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "create",
                  element: (
                    <RoleBasedGuard roles={["admin", "distributor"]}>
                      <CreateDistributorNoticesDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["admin", "distributor"]}>
                      <DistributorNoticesDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "rica-configuration",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <RicaConfigurationPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "sub-distributor-groups",
              children: [
                {
                  element: <Navigate to="/dashboard/admin/sub-distributor-groups/list" replace />,
                  index: true,
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <SubDistributorGroupsPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <SubDistributorGroupDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
          ],
        },
        {
          path: "customers",
          children: [
            {
              element: <Navigate to="/dashboard/customers/search" replace />,
              index: true,
            },
            {
              path: "search",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager"]}>
                  <CustomerListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "search/:id",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager"]}>
                  <CustomerDetailsPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "customer-care",
          children: [
            {
              path: "self-rica",
              children: [
                {
                  element: <Navigate to="/dashboard/customer-care/self-rica/list" replace />,
                  index: true,
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <SelfRicaDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <SelfRicaListPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "sim-swap",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <SimSwapPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "topup",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <TopUpPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "porting",
              children: [
                {
                  element: <Navigate to="/porting/port-in" replace />,
                  index: true,
                },
                {
                  path: "port-in",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <PortInListPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: ":msisdn",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <PortDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "rica-uplift-queue",
              children: [
                {
                  element : <Navigate to="/dashboard/customer-care/rica-uplift-queue/list" replace />,
                  index: true,
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <RicaUpliftQueueListPage />
                    </RoleBasedGuard>
                  ),
                }
              ]
            },
          ],
        },
        {
          path: "porting",
          children: [
            {
              element: <Navigate to="/dashboard/porting/port-in" replace />,
              index: true,
            },
            {
              path: "port-in",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <PortInListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ":msisdn",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <PortDetailsPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "wallets",
          children: [
            {
              element: <Navigate to="/dashboard/wallets/bulk-payments" replace />,
              index: true,
            },
            {
              path: "bulk-payments",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER ? ["distributor", "sub-distributor"] : ["admin"]}>
                  <BulkPaymentsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "account-bulk-payments",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER ? ["distributor", "sub-distributor"] : ["admin"]}>
                  <AccountBulkPaymentsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "batch-requests",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER ? ["distributor", "sub-distributor"] : ["admin"]}>
                  <WalletBatchRequestPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "batch-requests/:id",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER ? ["distributor", "sub-distributor"] : ["admin"]}>
                  <WalletBatchRequestDetailsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "merchant-accounts",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER ? ["distributor", "sub-distributor"] : ["admin"]}>
                  <WalletMerchantAccountsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "merchant-accounts/:id",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER ? ["distributor", "sub-distributor"] : ["admin"]}>
                  <WalletMerchantAccountTransactionHistoryPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "wallet-reports",
              element: (
                <RoleBasedGuard roles={["distributor"]} distributors={["Labour Market Activation Group (Pty) Ltd"]}>
                  <WalletReportsPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "subscriptions",
          children: [
            {
              element: <Navigate to="/dashboard/subscriptions/manage-subscriptions" replace />,
              index: true,
            },
            {
              path: "manage-subscriptions",
              element: (
                <RoleBasedGuard roles={["distributor"]}>
                  <SubscriptionsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "subscription-requests",
              children: [
                {
                  element: <Navigate to="/dashboard/subscriptions/subscription-requests/list" replace />,
                  index: true,
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["distributor"]}>
                      <BatchRequestPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["distributor"]}>
                      <BatchDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "active-subscriptions",
              element: (
                <RoleBasedGuard roles={["admin", "distributor"]}>
                  <ActiveSubscriptionsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ":id",
              element: (
                <RoleBasedGuard roles={["admin", "distributor"]}>
                  <ActiveSubscriptionsDetailsPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "products",
          children: [
            {
              element: <Navigate to="/dashboard/products/list" replace />,
              index: true,
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <ProductsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ":id",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <ProductDetailsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "product-group",
              children: [
                {
                  element: <Navigate to="/dashboard/products/product-group/list" replace />,
                  index: true,
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <ProductGroupPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <ProductGroupDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
          ],
        },

        {
          path: "rica",
          children: [
            {
              element: <Navigate to="/dashboard/rica/list" replace />,
              index: true,
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <RicaListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "self-rica",
              children: [
                {
                  element: <Navigate to="/dashboard/rica/self-rica/list" replace />,
                  index: true,
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <SelfRicaDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <SelfRicaListPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "images",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <SelfRicaImageListPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "image/:id",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <SelfRicaImageDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "form/:identifier",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "sub-distributor", "honey", "support_agent", "agent", "sub_distributor_manager"]}>
                  <SelfRicaFormPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "port",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "sub-distributor", "honey", "support_agent", "agent", "sub_distributor_manager"]}>
                  <PortInStartPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "uplift",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "sub-distributor", "honey", "support_agent", "agent", "sub_distributor_manager"]}>
                  <RicaUpliftPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "sim-swap",
          element: (
            <RoleBasedGuard roles={["admin"]}>
              <SimSwapPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: "topup",
          element: (
            <RoleBasedGuard roles={["admin"]}>
              <TopUpPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: "messaging",
          children: [
            {
              element: <Navigate to="/dashboard/messaging/list" replace />,
              index: true,
            },
            {
              path: ":id",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <MessagingDetailsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <MessagingListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "create",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <CreateMessagingDetailsPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "reports",
          children: [
            {
              element: <Navigate to="/dashboard/reports/list" replace />,
              index: true,
            },
            {
              path: ":id",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <ReportsDetailsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <ReportsListPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "iot",
          children: [
            {
              element: <Navigate to="/dashboard/iot/list" replace />,
              index: true,
            },
            {
              path: ":id",
              element: (
                <RoleBasedGuard roles={["admin", "iot"]}>
                  <IotDetailsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard roles={["admin", "iot"]}>
                  <IotListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "usage",
              element: (
                <RoleBasedGuard roles={["admin", "iot"]}>
                  <IotUsagePage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "rule",
              element: (
                <RoleBasedGuard roles={["admin", "iot"]}>
                  <IotRulePage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "sim-cards",
          children: [
            {
              element: <Navigate to="/dashboard/sim-cards/scan-out" replace />,
              index: true,
            },
            {
              path: "scan-out",
              element: (
                <RoleBasedGuard
                  roles={
                    selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER
                      ? ["admin", "distributor", "sub-distributor", "sub_distributor_manager", "sub_distributor_operations"]
                      : ["admin"]
                  }
                >
                  <SimScanOutPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "assignment",
              element: (
                <RoleBasedGuard roles={["admin", "distributor"]}>
                  <SimAssignmentPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "unassignment",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <SimUnassignmentPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "status",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "sub-distributor", "sub_distributor_manager", "sub_distributor_operations"]}>
                  <SimStatusPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "inner-box-status",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "sub-distributor", "sub_distributor_manager"]}>
                  <DistributorSimCardsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "scan-out-requests",
              element: (
                <RoleBasedGuard
                  roles={selectedRole?.distributor_i_customer === SPAR_DISTRIBUTOR_I_CUSTOMER ? ["sub-distributor", "sub_distributor_manager", "sub_distributor_manager"] : ["admin"]}
                >
                  <SimScanOutRequestsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "orders",
              children: [
                {
                  element: <Navigate to="/dashboard/sim-cards/orders/create" replace />,
                  index: true,
                },
                {
                  path: "create",
                  element: (
                    <RoleBasedGuard roles={["admin", "finance"]}>
                      <SimOrdersCreatePage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
          ],
        },
        {
          path: "sim-scanout",
          element: (
            <RoleBasedGuard roles={["admin", "distributor"]}>
              <SimScanOutPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: "sim-assignment",
          element: (
            <RoleBasedGuard roles={["admin", "distributor"]}>
              <SimAssignmentPage />
            </RoleBasedGuard>
          ),
        },
        // {
        //   path: "sim-orders",
        //   children: [
        //     {
        //       element: <Navigate to="/dashboard/sim-orders/list" replace />,
        //       index: true,
        //     },
        //     {
        //       path: ":id",
        //       element: (
        //         <RoleBasedGuard roles={["admin", "distributor"]}>
        //           <SimOrdersListPage />
        //         </RoleBasedGuard>
        //       ),
        //     },
        //     {
        //       path: "list",
        //       element: (
        //         <RoleBasedGuard roles={["admin", "distributor"]}>
        //           <SimOrdersListPage />
        //         </RoleBasedGuard>
        //       ),
        //     },
        //     {
        //       path: "create",
        //       element: (
        //         <RoleBasedGuard roles={["admin", "distributor"]}>
        //           <SimOrdersCreatePage />
        //         </RoleBasedGuard>
        //       ),
        //     },
        //   ],
        // },
        {
          path: "notices",
          children: [
            {
              element: <Navigate to="/dashboard/notices/list" replace />,
              index: true,
            },
            {
              path: ":id",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <NoticesDetailsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <NoticesListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "create",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <CreateNoticesDetailsPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "cx",
          children: [
            {
              path: "messaging",
              children: [
                {
                  element: <Navigate to="/dashboard/cx/messaging/list" replace />,
                  index: true,
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <MessagingDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <MessagingListPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "create",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <CreateMessagingDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "notices",
              children: [
                {
                  element: <Navigate to="/dashboard/cx/notices/list" replace />,
                  index: true,
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <NoticesDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <NoticesListPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "create",
                  element: (
                    <RoleBasedGuard roles={["admin"]}>
                      <CreateNoticesDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
          ],
        },
        {
          path: "distributors",
          children: [
            {
              element: <Navigate to="/dashboard/distributors/transactions" replace />,
              index: true,
            },
            {
              path: "transactions",
              element: (
                <RoleBasedGuard
                  roles={["admin", "distributor", "sub-distributor", "support_agent", "sub_distributor_manager", "sub_distributor_finance", "finance"]}
                >
                  <DistributorTransactionsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "dashboard",
              element: <DistributorDashboardPage />,
            },
            {
              path: "graphs",
              element: (
                <RoleBasedGuard roles={["distributor"]}>
                  <DashboardGraphsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "status-list",
              children: [
                {
                  element: <Navigate to="/dashboard/distributors/status-list/list" replace />,
                  index: true,
                },
                {
                  path: ":id",
                  element: (
                    // roles={selectedRole?.distributor_i_customer === SPAR_DISTRIBUTOR_I_CUSTOMER ? ["admin", "distributor"] : ["admin", "distributor"]}
                    <RoleBasedGuard
                      roles={
                        selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER
                          ? ["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager"]
                          : ["admin"]
                      }
                    >
                      <RicaDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard
                      roles={
                        selectedRole?.distributor_i_customer !== SPAR_DISTRIBUTOR_I_CUSTOMER
                          ? ["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager"]
                          : ["admin"]
                      }
                    >
                      <RicaListPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "customer-list",
              children: [
                {
                  element: (
                    <RoleBasedGuard roles={["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager"]}>
                      <CustomerListPage />
                    </RoleBasedGuard>
                  ),
                  index: true,
                },
                {
                  path: ":id", // New child route with id parameter
                  element: (
                    <RoleBasedGuard roles={["admin", "distributor", "support_agent", "sub-distributor", "sub_distributor_manager"]}>
                      <CustomerDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
            {
              path: "sales-report",
              element: (
                <RoleBasedGuard roles={["honey"]}>
                  <HoneySalesReportPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "distributor-report",
              element: (
                <RoleBasedGuard roles={["admin", "distributor"]}>
                  <DistributorReportPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "vouchers",
              children: [
                {
                  element: <Navigate to="/dashboard/vouchers/list" replace />,
                  index: true,
                },
                {
                  path: ":id",
                  element: (
                    <RoleBasedGuard roles={["admin", "distributor", "support_agent"]}>
                      <VoucherDetailsPage />
                    </RoleBasedGuard>
                  ),
                },
                {
                  path: "list",
                  element: (
                    <RoleBasedGuard roles={["admin", "distributor", "support_agent"]}>
                      <VoucherListPage />
                    </RoleBasedGuard>
                  ),
                },
              ],
            },
          ],
        },
        {
          path: "resellers",
          children: [
            {
              element: <Navigate to="/dashboard/resellers/transactions" replace />,
              index: true,
            },
            {
              path: "transactions",
              element: (
                <RoleBasedGuard roles={["distributor", "reseller"]}>
                  <ResellerTransactionsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "sell-product",
              element: (
                <RoleBasedGuard roles={["distributor", "reseller"]}>
                  <ResellerSellProductPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "vouchers",
          children: [
            {
              element: <Navigate to="/dashboard/vouchers/list" replace />,
              index: true,
            },
            {
              path: ":id",
              element: (
                <RoleBasedGuard hasContent roles={["admin", "support_agent"]}>
                  <VoucherDetailsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard hasContent roles={["admin", "support_agent"]}>
                  <VoucherListPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "training-videos",
          children: [
            {
              element: <Navigate to="/dashboard/training-videos/agent-videos" replace />,
              index: true,
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <TrainingVideosPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ":category/:id",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <UploadTrainingVideosPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "add",
              element: (
                <RoleBasedGuard roles={["admin"]}>
                  <UploadTrainingVideosPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "agent-videos",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "sub-distributor", "support_agent", "sub_distributor_manager", "agent"]}>
                  <AgentVideosPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "consumer-videos",
              element: (
                <RoleBasedGuard roles={["admin", "distributor", "sub-distributor", "support_agent", "sub_distributor_manager", "agent"]}>
                  <ConsumerVideosPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "sub-distributors",
          children: [
            {
              element: <Navigate to="/dashboard/sub-distributors/list" replace />,
              index: true,
            },
            {
              path: "list",
              element: (
                <RoleBasedGuard roles={["admin", "distributor"]}>
                  <SubDistributorsLevelsPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ":distributor_i_customer/id/:id/level/:level",
              element: (
                <RoleBasedGuard roles={["admin", "distributor"]}>
                  <SubDistributorsLevelsPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "rule-management",
          children: [
            {
              element: <Navigate to="/dashboard/rule-management/promo-rule" replace />,
              index: true,
            },
            {
              path: "/dashboard/rule-management/promo-rule",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer === SPAR_DISTRIBUTOR_I_CUSTOMER ? ["admin", "distributor", "sub-distributor"] : ["admin"]}>
                  <RulesManagementPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: "/dashboard/rule-management/new",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer === SPAR_DISTRIBUTOR_I_CUSTOMER ? ["admin", "distributor", "sub-distributor"] : ["admin"]}>
                  <AddNewRule />
                </RoleBasedGuard>
              ),
            },
            {
              path: "/dashboard/rule-management/view/:id",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer === SPAR_DISTRIBUTOR_I_CUSTOMER ? ["admin", "distributor", "sub-distributor"] : ["admin"]}>
                  <ManageRule />
                </RoleBasedGuard>
              ),
            },
            {
              path: "/dashboard/rule-management/product",
              element: (
                <RoleBasedGuard roles={selectedRole?.distributor_i_customer === SPAR_DISTRIBUTOR_I_CUSTOMER ? ["admin", "distributor", "sub-distributor"] : ["admin", "distributor"]}>
                  <RulesManagementProductPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: "self-service",
          children: [
            {
              path: "order",
              element: (
                <RoleBasedGuard roles={["sub-distributor"]}>
                  <DistributorSelfServiceOrderPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        // {
        //   path: "e-commerce",
        //   children: [
        //     {
        //       element: <Navigate to="/dashboard/e-commerce/shop" replace />,
        //       index: true,
        //     },
        //     { path: "shop", element: <EcommerceShopPage /> },
        //     { path: "product/:name", element: <EcommerceProductDetailsPage /> },
        //     { path: "list", element: <EcommerceProductListPage /> },
        //     { path: "product/new", element: <EcommerceProductCreatePage /> },
        //     {
        //       path: "product/:name/edit",
        //       element: <EcommerceProductEditPage />,
        //     },
        //     { path: "checkout", element: <EcommerceCheckoutPage /> },
        //   ],
        // },
        {
          path: "user",
          children: [
            {
              element: <Navigate to="/dashboard/user/account" replace />,
              index: true,
            },
            { path: "account", element: <UserAccountPage /> },
          ],
        },
        {
          path: "webhooks",
          children: [
            {
              element: <Navigate to="/dashboard/webhooks/manage" replace />,
              index: true,
            },
            { path: "manage", element: <ManageWebHooksPage /> },
          ],
        },
        {
          path: "reward-management",
          children: [
            {
              element: <Navigate to="/dashboard/reward-management/list" replace />,
              index: true,
            },
            {
              path: "/dashboard/reward-management/list",
              element: (
                <RoleBasedGuard roles={["distributor"]}>
                  <RewardManagementPages />
                </RoleBasedGuard>
              ),
            },
            {
              path: "/dashboard/reward-management/new",
              element: (
                <RoleBasedGuard roles={["distributor"]}>
                  <AddNewReward />
                </RoleBasedGuard>
              ),
            },
            {
              path: "/dashboard/reward-management/view/:id",
              element: (
                <RoleBasedGuard roles={["distributor"]}>
                  <ManageReward />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        { path: "blank", element: <BlankPage /> },
      ],
    },

    // Main Routes — MainLayout removed in SWOT template cleanup; redirect handled directly
    {
      path: "/",
      element: <Navigate to="/auth/account-select" replace />,
    },
    {
      element: <CompactLayout />,
      children: [
        { path: "500", element: <Page500 /> },
        { path: "404", element: <Page404 /> },
        { path: "403", element: <Page403 /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
